/* Insert polyfills here, they will be executed before running the app */
// IE11 support
import 'react-app-polyfill/ie11';